import { request, success, failure, DAILY_ATTENDANCE_REQUEST, ATTENDANCE_REQUEST, ATTENDANCE } from "./utilities";
import { getDailyAttendanceReport, getEmployeeAttendanceReport } from "../api";
import { PostRequest } from "../api/genericApiCalls";
import { APP_SETTINGS } from "../../config";


export function AttendanceReportAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(ATTENDANCE.ATTENDANCE_REPORT_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.ATTENDANCE.attendanceReport, reqObject, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(ATTENDANCE.ATTENDANCE_REPORT_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(ATTENDANCE.ATTENDANCE_REPORT_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(ATTENDANCE.ATTENDANCE_REPORT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

        // var response = {
        //     present: 30,
        //     offBase: 25,
        //     absent: 12,
        //     break: 3,
        //     attendance: [
        //         {
        //             id: 0,
        //             name: "Ahmed Sultan Mirza",
        //             profilePictue: "https://thedocappstorage.blob.core.windows.net:443/visioncollab/02042020081357_dpahmed.jpg",
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 1,
        //             name: "Faizan Rajab",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 2,
        //             name: "Rana Waqas",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 3,
        //             name: "Usama Ikram",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 4,
        //             name: "Ayaz Qaiser",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 5,
        //             name: "Touseef",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 6,
        //             name: "Nouman",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 7,
        //             name: "Aamir",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 9,
        //             name: "Hassan Ali",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         },
        //         {
        //             id: 9,
        //             name: "Shehreyar",
        //             profilePictue: null,
        //             lateComing: 1,
        //             idleHours: 2,
        //             productiveHour: 2,
        //             checkIn: "10:20"
        //         }
        //     ]
        // }
        // dispatch(success(DAILY_ATTENDANCE_REQUEST.GET_DAILY_ATTENDANCE_REPORT_SUCCESS, response))

 // var response = {
        //     present: 30,
        //     offBase: 25,
        //     absent: 12,
        //     break: 3,
        //     attendance_report: [
        //         {
        //             id: 0,
        //             name: "Ahmed Sultan Mirza",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 1,
        //             name: "Faizan Rajab",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 2,
        //             name: "Rana Waqas",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 3,
        //             name: "Usama Ikram",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 4,
        //             name: "Ayaz Qaiser",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 5,
        //             name: "Touseef",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 6,
        //             name: "Nouman",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 7,
        //             name: "Aamir",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 9,
        //             name: "Hassan Ali",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         },
        //         {
        //             id: 9,
        //             name: "Shehreyar",
        //             attendance: [true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true]

        //         }
        //     ]
        // }
        // dispatch(success(ATTENDANCE_REQUEST.GET_ATTENDANCE_REPORT_SUCCESS, response))